module.exports = __webpack_public_path__ + "static/media/1549576549406-297919156.6f237929.jpg";